import { render, staticRenderFns } from "./BssRowMobile.vue?vue&type=template&id=0f8759e0&scoped=true&"
import script from "./BssRowMobile.vue?vue&type=script&lang=ts&"
export * from "./BssRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./BssRowMobile.vue?vue&type=style&index=0&id=0f8759e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8759e0",
  null
  
)

export default component.exports